function isBrowser() {
  return typeof window !== 'undefined';
}

export default {
  beforeMount: function (element, binding, node) {
    let shouldListen = true;

    function handler(e) {
      if (!node) return;

      let elements = e.path || (e.composedPath && e.composedPath());
      elements && elements.length > 0 && elements.unshift(e.target);

      if (element.contains(e.target) || !element.__clickOutside__ || !shouldListen) return;

      element.__clickOutside__.callback(e);
    }

    function onPointerDown(e) {
      shouldListen = !!element && !e.composedPath().includes(element);
    }

    element.__clickOutside__ = {
      handler: handler,
      onPointerDown,
      callback: binding.value,
    };
    if (isBrowser()) {
      window.addEventListener('click', handler, true);
      window.addEventListener('pointerdown', onPointerDown);
    }
  },

  updated: function (element, binding) {
    element.__clickOutside__.callback = binding.value;
  },

  unmounted: function (element, binding, node) {
    if (isBrowser()) {
      window.removeEventListener('click', element.__clickOutside__.handler);
      window.removeEventListener('pointerdown', element.__clickOutside__.onPointerDown);
    }
    delete element.__clickOutside__;
  },
};
